/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { userActivityTypes } from "../../pages/data/DataView";
import { parseDate } from "../../util/DateTime";

export const parseClientInfo = (guest, activityLogs) => {
  const gdprAccepted = guest.gdpr_accepted;
  const data = {
    clientId: guest.client_id,
    guestId: guest.id,
    clientName: guest.client_name,
    name: guest.name,
    birthday: parseDate(guest.birthday),
    country: guest.country,
    email: guest.email,
    emailStatic: guest.email_static ?? false,
    phoneNumber: guest.phone_number,
    smsStatic: guest.smsstatic ?? false,
    loyalty: guest.loyalty_status,
    language: guest.language,
    timezone: guest.timezone,
    optedIn: gdprAccepted == null ? null : !!gdprAccepted,
  }

  if (activityLogs != null) {
    const activityIdMap = {}
    Object.keys(userActivityTypes).forEach((key) => {
      const value = userActivityTypes[key];
      activityIdMap[value.cloudKey] = key;
    });
    data.activity = activityLogs?.map(log => ({
      type: activityIdMap[log.event_type],
      timestamp: log.created_at,
    }));
  }

  return data;
};

export const parseGuestAccount = (account) => {
  const gdprAccepted = account.gdpr_accepted;
  return {
    clientId: account.client_id,
    clientName: account.client_name,
    guestId: account.guest_id,
    guestUsernane: account.guest_username,
    optedIn: gdprAccepted == null ? null : !!gdprAccepted,
  };
};

export const parseGuestAccountList = (accountList) => {
  return accountList.map(account => parseGuestAccount(account));
};
